var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcMenuTransformations = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C13.79 12 12 13.79 12 16C12 18.21 13.79 20 16 20C18.21 20 20 18.21 20 16C20 13.79 18.21 12 16 12ZM24.94 15C24.48 10.83 21.17 7.52 17 7.06V6C17 5.45 16.55 5 16 5C15.45 5 15 5.45 15 6V7.06C10.83 7.52 7.52 10.83 7.06 15H6C5.45 15 5 15.45 5 16C5 16.55 5.45 17 6 17H7.06C7.52 21.17 10.83 24.48 15 24.94V26C15 26.55 15.45 27 16 27C16.55 27 17 26.55 17 26V24.94C21.17 24.48 24.48 21.17 24.94 17H26C26.55 17 27 16.55 27 16C27 15.45 26.55 15 26 15H24.94ZM16 22.6667C12.13 22.6667 9.33333 19.87 9.33333 16C9.33333 12.13 12.13 9.33333 16 9.33333C19.87 9.33333 22.6667 12.13 22.6667 16C22.6667 19.87 19.87 22.6667 16 22.6667Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcMenuTransformations, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-menu-transformations.e3507f9a.svg";
export { ForwardRef as ReactComponent };